/* eslint-disable camelcase */
import Api from '../api';

export const getCitiesByStates = async (states: Array<Number>) => {
  const params = states?.map((state) => `states_ids[]=${state}`).join('&');

  const response = await Api.get(`/cities.json?${params}`);

  return response.data;
};
